<template>
  <article class="padded b-project b-project-fe">
    <main>
      <section class="project-about project-section project-fe__section">
        <h1>Front-End</h1>
        <p>
          From time to time, I complete side projects.
        </p>
      </section>
      <section class="project-section project-fe__section  project-fe__grid">
        <a
          href="https://play-sets.netlify.app"
          target="_blank"
          rel="noopener noreferrer"
          class="fe-project card"
        >
          <img src="/assets/images/icons/link.svg" class="external-link" />
          <img
            src="/assets/images/projects/FrontEnd/play-sets.svg"
            class="fe-project__image"
          />
          <p class="fe-project__description">
            A game of sets with Standard & Beginner modes.
          </p>
        </a>
        <a
          href="https://css-backgrounds.netlify.app/"
          target="_blank"
          rel="noopener noreferrer"
          class="fe-project card"
        >
          <img src="/assets/images/icons/link.svg" class="external-link" />
          <img
            src="/assets/images/projects/FrontEnd/css-backgrounds.png"
            class="fe-project__image"
          />
          <p class="fe-project__description">
            Background made with CSS Gradients. Copyable code to use in projects
          </p>
        </a>
      </section>
      <section class="project-section project-fe__section">
        <p>...and of course, this site ;)</p>
        <p>
          Some more experiments on
          <a
            href="https://github.com/poulamic?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
            >Github</a
          >
        </p>
      </section>
    </main>
  </article>
</template>

<script>
export default {}
</script>

<style scoped>
.project-fe__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, 24rem);
  grid-gap: var(--padding-lg);
}
.fe-project {
  width: 100%;
  position: relative;
}
.fe-project__image {
  margin: var(--padding-sm) auto;
}
</style>
